<template>
  <div class="vip-page">
    <header class="vip-header">
      <button
        class="back-btn"
        type="button"
        aria-label="back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('user.level') }}</h1>
    </header>

    <main class="vip-list">
      <article
        v-for="(item, index) in displayVips"
        :key="item.id || index"
        class="vip-card"
      >
        <img
          class="vip-badge"
          :src="item.pic"
          alt=""
        >
        <div class="vip-info">
          <p>
            <span>{{ $t('vip2.saleRate') }}:</span>
            <strong>{{ formatRate(item.rate) }} %</strong>
          </p>
          <p>
            <span>{{ $t('vip2.depositAmount') }}:</span>
            <strong>{{ formatDeposit(item, index) }} USD</strong>
          </p>
          <p>
            <span>{{ $t('vip2.taskQuantity') }}:</span>
            <strong>{{ formatTasks(item, index) }}</strong>
          </p>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: "Vip",
  data() {
    return {
      data: null,
      vips: [],
      app: null,
      acc: null,
      show_kefu: false,
      msg_show: true,
      badges: [
        require('../images/user/vip_badge_1.png'),
        require('../images/user/vip_badge_2.png'),
        require('../images/user/vip_badge_3.png'),
        require('../images/user/vip_badge_4.png'),
        require('../images/user/vip_badge_5.png'),
      ],
      fallbackDeposits: ['99-1001', '1001-2000', '2001-5000', '5001-10000', '10001-1000000'],
      fallbackTasks: [20, 30, 30, 40, 50],
    };
  },
  computed: {
    displayVips() {
      return Array.isArray(this.vips) ? this.vips : [];
    },
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.start();
    document.body.addEventListener("scroll", this.handleBodyScroll, false);
    document.addEventListener("click", this.handleDocumentClick, false);
  },
  beforeDestroy() {
    document.body.removeEventListener("scroll", this.handleBodyScroll, false);
    document.removeEventListener("click", this.handleDocumentClick, false);
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
      Fetch("/user/basicinfo").then((r) => {
        this.data = r.data;
        this.acc = r.data;
        this.vips = r.data && Array.isArray(r.data.vips) ? r.data.vips : [];
      });
    },
    badgeImage(index) {
      return this.badges[index % this.badges.length];
    },
    formatRate(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        number = 0;
      }
      return number.toFixed(2);
    },
    formatDeposit(item, index) {
      if (item && item.minn && item.maxn) {
        return item.minn + ' - ' + item.maxn;
      }
      if (item && item.value) {
        var current = Number(item.value);
        var previous = index > 0 && this.displayVips[index - 1] ? Number(this.displayVips[index - 1].value) : 99;
        if (isFinite(current) && isFinite(previous)) {
          return Math.floor(previous) + ' - ' + Math.floor(current);
        }
      }
      return this.fallbackDeposits[index] || this.fallbackDeposits[this.fallbackDeposits.length - 1];
    },
    formatTasks(item, index) {
      var keys = ['task_num', 'tasks', 'task', 'num', 'onum', 'order_num'];
      for (var i = 0; i < keys.length; i++) {
        var value = item && item[keys[i]];
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }
      return this.fallbackTasks[index] || this.fallbackTasks[this.fallbackTasks.length - 1];
    },
    handleBodyScroll() {
      if (this.show_kefu) {
        this.show_kefu = false;
      }
    },
    handleDocumentClick(ev) {
      if (!ev.target || ev.target.className !== "kefu_img") {
        this.show_kefu = false;
      }
    },
    kefu_to() {
      if (this.show_kefu && this.app && this.app.kefu_link) {
        var uid = this.acc && this.acc.user && this.acc.user.id ? this.acc.user.id : '';
        var name = this.acc && this.acc.user && this.acc.user.phone ? this.acc.user.phone : '';
        window.location.href = this.app.kefu_link + '&uid=' + uid + '&name=' + name;
        return;
      }
      this.show_kefu = !this.show_kefu;
    },
  },
};
</script>

<style lang="less" scoped>
.vip-page {
  min-height: 100vh;
  padding-bottom: 100px;
  background: #f4f5fb;
  color: #1f2933;
}

.vip-header {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vip-header h1 {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #1f2933;
}

.back-btn {
  position: absolute;
  left: 18px;
  top: 13px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  color: #0e1826;
}

.back-btn .van-icon {
  font-size: 24px;
}

.vip-list {
  padding: 15px 14px 0;
}

.vip-card {
min-height: 100px;
display: flex;
align-items: center;
margin-bottom: 5px;
padding: 0 5px;
border-radius: 11px;
background: #fff;
border: 1px solid #e2e4ec;
box-shadow: 0 1px 2px rgba(22, 28, 45, 0.02);
box-sizing: border-box;
}

.vip-badge {
  width: 96px;
  height: 92px;
  flex: 0 0 96px;
  object-fit: contain;
}

.vip-info {
  min-width: 0;
  padding-left: 10px;
}

.vip-info p {
  display: flex;
  align-items: baseline;
  margin: 0 0 5px;
  font-size: 12px;
  line-height: 18px;
  color: #626c78;
}

.vip-info p:last-child {
  margin-bottom: 0;
}

.vip-info span {
  white-space: nowrap;
}

.vip-info strong {
  min-width: 0;
  margin-left: 5px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  color: #1f2933;
  word-break: break-word;
}

.kefu {
  position: fixed;
  right: 28px;
  bottom: 95px;
  z-index: 12;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  background: #1787ff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
  transition: transform .25s ease;
  box-sizing: border-box;
}

.kefu_hide {
  transform: translateX(38px);
}

.kefu_img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 38px;
  font-weight: 700;
}
</style>
